// extracted by mini-css-extract-plugin
module.exports = {"dashboardContainer":"AdminSelectGym_dashboardContainer__aG30M"};